import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {ControlPanelComponent} from './control-panel.component';
import {AuthGuard} from '../login/auth.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'preferences', component: ControlPanelComponent,canActivate: [AuthGuard]}

    ])
  ],
  exports: [
    RouterModule
  ]
})
export class ControlPanelRoutingModule { }
